import { all } from "redux-saga/effects";
import { loginWatcherSaga } from "./Login/login.saga";
import { employeeFlowWatcherSaga } from "./EmployeeFlow/employeeFlow.saga";
import { hospitalManagementWatcherSaga } from "./HospitalManagement/hospitalManagement.saga";
import { listingWatcherSaga } from "./ListingApi/listingApi.saga";
import { candidateFlowWatcherSaga } from "./CandidateRegistrationFlow/saga";
import { candidateManagementWatcherSaga } from "./CandidateManagement/CandidateManagement.saga";
import { staffManagementWatcherSaga } from "./StaffManagement/staffManagement.saga";
import { subscriptionManagementWatcherSaga } from "./SubscriptionManagement/subscriptionManagement.saga";

export default function* rootSaga() {
  yield all([
    loginWatcherSaga(),
    employeeFlowWatcherSaga(),
    hospitalManagementWatcherSaga(),
    listingWatcherSaga(),
    candidateFlowWatcherSaga(),
    candidateManagementWatcherSaga(),
    staffManagementWatcherSaga(),
    subscriptionManagementWatcherSaga(),
  ]);
}
